import Select from '@components/v2/form/Select/Select';
import { SelectOption } from '@components/v2/form/Select/select.types';
import { useController, useFormContext } from 'react-hook-form';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import {
  CatalogCreationBooleanFieldName,
  CatalogCreationBooleanOptions,
  CatalogCreationFormInput,
} from '../catalogCreationForm.types';

interface CatalogCreationBooleanSelectFieldProps {
  name: CatalogCreationBooleanFieldName;
  label: LangEnum;
  options: CatalogCreationBooleanOptions;
  testId?: string;
}

const ENABLED_OPTION_VALUE = 'true';

const CatalogCreationBooleanSelectField = ({
  name,
  label,
  options,
  testId,
}: CatalogCreationBooleanSelectFieldProps) => {
  const { translate } = useTranslation();
  const { control } = useFormContext<CatalogCreationFormInput>();
  const { field, fieldState } = useController({ control, name });

  const selectOptions: SelectOption[] = options.map((option) => ({
    value: String(option.value),
    label: translate(option.label),
  }));

  return (
    <Select
      options={selectOptions}
      label={translate(label)}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      testId={testId}
      {...field}
      value={String(field.value)}
      onChange={(event) => field.onChange(event.target.value === ENABLED_OPTION_VALUE)}
    />
  );
};

export default CatalogCreationBooleanSelectField;
